import {
    Component,
    ElementRef,
    HostListener,
    Input,
    OnInit,
    ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Title } from '@angular/platform-browser';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import * as Joi from 'joi';
import { Subject, filter, lastValueFrom, takeUntil } from 'rxjs';
import { HttpNewService } from 'src/app/services/application/http-new.service';
import { Store } from 'src/app/services/store.service';
import { AlertService } from 'src/lib/ariadna/alert';
import { IDocuments } from '../../interfaces/document.interfaces';
import {
    IContract,
    IPatient,
    IResultEmailUpdate,
    ITokenAndPatientId,
    IUnsignedPayContract,
    IResponseGetRecordLog,
} from '../../interfaces/patient.interfaces';
import { ChangePwComponent } from '../../modals/change-pw/change-pw.component';
import { CreatePwComponent } from '../../modals/create-pw/create-pw.component';
import { DocImgComponent } from '../../modals/doc-img/doc-img.component';
import { ConfigService } from '../../services/application/config.service.';
import { LoadService } from '../../services/application/load.service';
import { AuthService } from '../../services/auth.service';
import { FileUploadService } from '../../services/file-upload.service';
import { PatientService } from '../../services/patient.service';
import { Size } from '../../services/size';
import { Utils } from '../../services/utils';
import {
    getNameDay,
    getTekDay,
    getTime,
    strToDate,
} from '../application/global.function';
import { PaginationComponent } from '../shared/pagination/pagination.component';
import { ContractService } from 'src/app/services/contract.service';
import { DateTime } from 'luxon';
import {
    APP_DATE_FORMATS,
    formatUiDateTime,
    parseDateTime,
} from 'src/app/shared/date/date.utils';
import { EmailInputModalComponent } from 'src/app/modals/email-input/email-input.component';

@Component({
    selector: 'app-account',
    templateUrl: './account.component.html',
    styleUrls: ['./account.component.scss'],
    standalone: false,
})
export class AccountComponent implements OnInit {
    public patient!: IPatient | null;
    public deviceType: string = '';
    @ViewChild('ContentBlockFioAndDoc') public ContentBlockFioAndDocEL:
        ElementRef | undefined;
    @ViewChild('ContentBlockFio') public ContentBlockFioEL:
        ElementRef | undefined;
    @Input() public tmpToken: ITokenAndPatientId | null = null; //токен

    public panelDocSetStyle = { height: '130px' };
    public contracts!: IContract[];
    public documents!: IDocuments[];
    public contractsCountRec = 0; // Количество документов
    public docCountRec = 0; // Количество документов doc
    public patientLogs!: IResponseGetRecordLog[]; // Логи пациента
    public patientLogsCountRec = 0; // Всего записей
    public patientLogsCountRectoPage = 10; // Количетсво записей на странице
    public isFirstPatientLogin = false;

    public loadingContracts = false; // Загрузка подписанных документов
    public loading = false; // Загрузка общая

    public canChangeEmail = false;

    public blockBodystyleHeight = { height: 'auto' };

    public showPanelDocOld = false; // Показывать панель всех документов

    public counter = 0;
    public payContracts: Array<IUnsignedPayContract> = [];
    public modalReference!: NgbModalRef;
    public exitModal = false;
    public isChangePassword = true;
    public mobilePhone = '';
    public newEmail: string = '';

    public isMobile: boolean = false;
    private resizeHandler!: () => void;
    private destroy$ = new Subject<void>();

    public constructor(
        private ps: PatientService,
        private auth: AuthService,
        private configS: ConfigService,
        private contractService: ContractService,
        private size: Size,
        private dialog: MatDialog,
        private load: LoadService,
        private fu: FileUploadService,
        private title: Title,
        private alertService: AlertService,
        private modalService: NgbModal,
        private httpNew: HttpNewService,
    ) {
        const tmpTitle =
            load.configData?.CLIENT_SETTINGS.PAGES_SETTINGS.PERSONAL.TITLE;
        if (tmpTitle) this.title.setTitle(tmpTitle);

        this.deviceType = this.size.getDeviceType();
        this.size.onResize$().subscribe((val) => {
            let h = val.outletH;

            if (val.blockHeaderH && val.blockHeaderH > 0) {
                h = h - val.blockHeaderH;
            }
            h = h - 20; //отступ от футтера
            this.blockBodystyleHeight.height = h + 'px';
        });
    }

    public ngOnInit(): void {
        this.loading = true;
        this.deviceType = this.size.getDeviceType();
        this.checkIsMobile();
        this.setupResizeHandler();
        this.getPatientInfo();
        this.getContractList();
        this.getPayContractList();
        this.isChangePassword = this.isChangePasswordAccess();
        if (
            this.load.configData?.CLIENT_SETTINGS.PAGES_SETTINGS.PERSONAL
                .IS_CAN_CHANGE_EMAIL
        ) {
            this.canChangeEmail = true;
        }

        this.get_log();
    }

    public ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
        if (this.resizeHandler) {
            window.removeEventListener('resize', this.resizeHandler);
        }
    }
    private setupResizeHandler(): void {
        this.resizeHandler = () => {
            this.checkIsMobile();
            this.calcTableH();
        };
        window.addEventListener('resize', this.resizeHandler);
    }

    private checkIsMobile(): void {
        this.isMobile = window.innerWidth < 768; // Standard breakpoint for mobile
    }

    public closeModal() {
        this.modalReference.close();
    }
    public isChangePasswordAccess(): boolean {
        return Store.getDataString('ParentCookieName') ? false : true;
    }

    public get_log() {
        this.ps.getInetuserLogSize$().subscribe(
            (info) => {
                if (info.size) {
                    this.patientLogsCountRec = parseInt(info.size);
                    this.getPatientLog(1, this.patientLogsCountRectoPage);
                }
            },
            (err) => {
                this.patientLogsCountRec = 0;
            },
        );
    }
    // Отслеживание изменений размера
    @HostListener('window:resize', ['$event'])
    public onResize(event: any) {
        this.calcTableH();
    }

    /* расчет высоты блока относительно */
    private calcTableH() {
        if (this.deviceType == this.size.pc) {
            if (
                this.ContentBlockFioAndDocEL &&
                this.ContentBlockFioEL &&
                this.ContentBlockFioAndDocEL.nativeElement &&
                this.ContentBlockFioEL.nativeElement
            ) {
                let h =
                    this.ContentBlockFioAndDocEL.nativeElement.offsetHeight -
                    this.ContentBlockFioEL.nativeElement.offsetHeight;

                h = h - 30;
                this.panelDocSetStyle = { height: `${h}px` };
            }
        }
    }

    private getPatientInfo(): void {
        this.ps.fetchPatientInfo().subscribe();
        this.ps.patient$
            .pipe(
                filter((patient): patient is IPatient => !!patient),
                takeUntil(this.destroy$),
            )
            .subscribe({
                next: (patient) => {
                    this.patient = patient;
                    this.isFirstPatientLogin = this.patient?.countLogin
                        ? this.patient.countLogin === 0
                        : false;
                    this.mobilePhone = this.patient?.cellular || '';
                    setTimeout(() => this.calcTableH(), 100);
                },
                error: (err) => {
                    console.error('❌ Ошибка получения данных пациента:', err);
                    try {
                        this.auth.logout();
                    } catch {}
                },
            });
    }

    public getDocumentsList(): void {
        this.documents = [];
        this.docCountRec = 0;
        this.fu.getDocList().subscribe({
            next: (info) => {
                this.documents = info;
                this.documents.forEach((item) => {
                    item.dat = strToDate(item.datStr);
                });

                this.docCountRec = this.documents.length;
            },
            error: (err) => {
                this.docCountRec = 0;
            },
        });
    }

    public getContractList(): void {
        this.loadingContracts = true;
        this.contracts = [];
        this.contractsCountRec = 0;

        this.contractService.getContractListToPatient().subscribe({
            next: (info) => {
                this.contracts = this.sortContractsByDate(info);
                this.contractsCountRec = this.contracts.length;
                this.loadingContracts = false;
            },
            error: (err) => {
                this.contractsCountRec = 0;
                this.loadingContracts = false;
            },
        });
    }
    @ViewChild('pagination', { static: false })
    public paginationComponentRef!: PaginationComponent;
    public getPatientLog(pStart?: number, pEnd?: number): void {
        if (this.currentPage === 1) {
            setTimeout(() => {
                if (this.paginationComponentRef) {
                    this.paginationComponentRef.currentPage = 1; // Прямое обновление currentPage
                    this.paginationComponentRef.generPageName(1); // Перегенерация страниц
                }
            }, 0);
        }
        this.ps.getInetuserLog$(pStart, pEnd).subscribe({
            next: (info) => {
                this.patientLogs = info;
                this.patientLogs.forEach((item) => {
                    item.date = strToDate(item.datStr);
                    item.dateNormalized = this.getDateTime(item.date);
                });
                this.loading = false;
            },
            error: (err) => {
                this.patientLogs = [];
                this.loading = false;
            },
        });
    }

    public getDateTime(date: Date): string {
        return formatUiDateTime(date);
    }
    public currentPage: number = 1;
    /* Событие выбора страницы */
    public changedPage(page: number) {
        if (page === this.currentPage) return;
        this.currentPage = page;
        if (page == 1) {
            this.getPatientLog(1, this.patientLogsCountRectoPage);
        } else {
            this.getPatientLog(
                page * this.patientLogsCountRectoPage -
                    this.patientLogsCountRectoPage,
                page * this.patientLogsCountRectoPage,
            );
            this.currentPage = page;
        }
    }

    /* открыть контракт */
    public async openContract(contractId: number) {
        try {
            const signedContract = await lastValueFrom(
                this.contractService.getSignedContract(contractId.toString()),
            );
            if (!signedContract) {
                this.alertService.warn(
                    'Документ поврежден! Обратитесь в медицинскую организацию',
                );
                return;
            }
            const file = new File(
                [new Uint8Array(signedContract.data)],
                `contract_${contractId}.pdf`,
                {
                    type: 'application/pdf',
                },
            );
            const fileURL = URL.createObjectURL(file);
            const link = document.createElement('a');
            link.href = fileURL;
            link.rel = 'noopener norefferrer';
            link.download = `contract_${contractId}.pdf`;
            document.body.appendChild(link);
            link.click();
            setTimeout(() => {
                document.body.removeChild(link);
                URL.revokeObjectURL(fileURL);
            }, 60_000);
        } catch (err: unknown) {
            const error = Utils.getErrorMessage(
                err,
                'Не удалось открыть документ',
            );
            this.alertService.error(error);
        }
    }

    /* Смена пароля */
    public changePW() {
        if (window.innerWidth <= 500) {
            const dialogRef = this.dialog.open(ChangePwComponent, {
                width: '100%',
                minWidth: '100vw',
                // maxWidth: '100vw',
                height: '100%',
                closeOnNavigation: true,
                data: {},
            });
        } else {
            const dialogRef = this.dialog.open(ChangePwComponent, {
                width: '70vw',
                maxWidth: '770px',
                height: 'auto',
                // width: '80vw',
                closeOnNavigation: true,
                data: {},
            });
        }
    }
    public openModal(e: Event) {
        if (!this.canChangeEmail) {
            return;
        }
        e.stopPropagation();
        const dialogRef = this.dialog.open(EmailInputModalComponent, {
            data: {
                email: this.patient?.email,
                message: 'Укажите почтовый адрес',
            },
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.newEmail = result.newEmail;
                this.saveEmail();
            }
        });
    }

    /* Генерация пароля */
    public createPW() {
        const dialogRef = this.dialog.open(CreatePwComponent, {
            width: 'auto',
            height: 'auto',
            closeOnNavigation: true,
            data: {},
        });
    }

    public getDocList(): void {
        this.contracts = [];
        this.contractsCountRec = 0;

        this.contractService.getContractListToPatient().subscribe({
            next: (info) => {
                this.contracts = this.sortContractsByDate(info);
                this.contractsCountRec = this.contracts.length;
            },
            error: (err) => {
                this.contractsCountRec = 0;
            },
        });
    }

    public addDoc(): void {
        const dialogRef = this.dialog.open(DocImgComponent, {
            width: 'auto',
            height: 'auto',
            closeOnNavigation: true,
            data: null,
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result && result.success) {
                // Нормально
                this.alertService.info('Документ добавлен.');
                this.getDocumentsList();
            } else {
                if (result.msg) {
                    this.alertService.error(result.msg);
                }
            }
        });

        // this.alertService.error(errCPbyR);
    }

    private sortContractsByDate(contracts: IContract[]): IContract[] {
        return contracts
            .map((contract, index) => ({
                contract,
                index,
                timestamp: this.getContractTimestamp(contract.dat),
            }))
            .sort((left, right) => {
                if (left.timestamp === null && right.timestamp === null) {
                    return left.index - right.index;
                }
                if (left.timestamp === null) return 1;
                if (right.timestamp === null) return -1;

                return (
                    right.timestamp - left.timestamp || left.index - right.index
                );
            })
            .map(({ contract }) => contract);
    }

    private getContractTimestamp(value: string): number | null {
        if (!value) return null;

        const formats = [
            'dd.MM.yyyy HH:mm:ss',
            'dd.MM.yyyy HH:mm',
            APP_DATE_FORMATS.INPUT_DATE,
            'yyyy-MM-dd HH:mm:ss',
            APP_DATE_FORMATS.API_DATE,
        ];

        for (const format of formats) {
            const date = parseDateTime(value, format);
            if (date) return date.toMillis();
        }

        const isoDate = DateTime.fromISO(value);
        return isoDate.isValid ? isoDate.toMillis() : null;
    }

    public saveEmail(): void {
        if (!this.newEmail) {
            return;
        }
        const emailSchema = Joi.string().email({ tlds: { allow: false } });
        const isValid = !emailSchema.validate(this.newEmail).error;
        if (!isValid) {
            this.newEmail = '';
            this.alertService.error(`Неправильный формат почты`, 5000);
            this.closeModal();
            return;
        }

        this.auth.updateEmail(this.newEmail).subscribe({
            next: (result) => {
                if (result) {
                    this.patient!.email = this.newEmail;
                    this.alertService.success('Почта успешно обновлена', 5000);
                    this.newEmail = '';
                    this.closeModal();
                }
            },
            error: (error: unknown) => {
                if (error) {
                    this.alertService.error(
                        Utils.getErrorMessage(error, 'Ошибка'),
                        5000,
                    );
                    this.newEmail = '';
                    this.closeModal();
                }
            },
        });
    }

    public getTekDay(dt: Date | undefined): string {
        if (dt) {
            return getTekDay(dt);
        } else {
            return '';
        }
    }

    public getNameDay(dt: Date): string {
        return getNameDay(dt);
    }

    public getTime(dt: Date): string {
        return getTime(dt);
    }

    public smsEmmitter($event: boolean) {
        if ($event) this.getContractList();
        this.getPayContractList();
    }

    private getPayContractList(): void {
        this.ps.getPayContract().subscribe({
            next: (docs) => {
                this.payContracts = docs;
                this.docCountRec = this.documents?.length;
            },
            error: (err) => {
                this.docCountRec = 0;
            },
        });
    }

    // public isValidEmailInput(): boolean {
    //     const trimmedEmail = this.newEmail.trim();
    //     if (trimmedEmail.length === 0) return false;
    //     const emailSchema = Joi.string().email({ tlds: { allow: false } });
    //     return !emailSchema.validate(trimmedEmail).error;
    // }
}
